/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import { getAuthHeader } from 'ui-internal-account/src/utilities/internalSecurityUtil';
import * as types from '../constants';

const authInstance = axios.create({
    baseURL: `${process.env.API}${types.CAMP_BASEPATH}`,
    headers: {
        Authorization: getAuthHeader(),
    },
});

authInstance.interceptors.request.use((config) => {
    const newConfig = { ...config };
    newConfig.headers.Authorization = getAuthHeader();
    return newConfig;
});

export const internalAuthCampingAxios = authInstance;
